import React from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  UnauthorisedPageSurface,
  PageWrapper,
} from "../../../../components/layout/container/Container";
import { FormSection } from "../../../../components/layout/forms/Index";
import TextField from "../../../../components/input/textfield/TextField";

import { useForgotPassword } from "../hooks/useForgotPassword";
import StatusAlert from "../../../../components/alerts/StatusAlert";
import Button from "../../../../components/buttons/Button";
import { PageHeader } from "../../../../components/layout/header/Header";
import { PageHeading } from "../../../../components/common/heading/Heading";
import FeedbackStatus from "../../../../components/feedback/FeedbackStatus";

import "./ForgotPasswordPage.css";

const ForgotPasswordPage = () => {
  document.title = "Katch | Forgot Password";

  const navigate = useNavigate();
  const { email, setEmail, status, handleSubmit } = useForgotPassword();

  if (status.success) {
    return (
      <div className="forgot-password-content">
        <FeedbackStatus
          title={"Check your email"}
          description={
            <span>
              If an account exists for <b>{email || "this email"}</b>, you’ll
              receive password reset instructions shortly. Be sure to check your
              inbox or spam folder.
            </span>
          }
          buttonText={"Back to Sign in"}
          onAction={() => navigate("/sign-in")}
        />
      </div>
    );
  }

  return (
    <UnauthorisedPageSurface>
      <PageWrapper size={"sm"}>
        <div className="forgot-password-content">
          <PageHeader>
            <PageHeading
              title={"Forgot password"}
              subTitle={
                <span>
                  Remember your password?{" "}
                  <Link
                    to="/sign-in"
                    style={{ color: "var(--ko-primary-blue-3)" }}
                  >
                    Sign in
                  </Link>
                </span>
              }
            />
          </PageHeader>

          <FormSection>
            {status.message && <StatusAlert status={status} />}

            <TextField
              type="email"
              label="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g. name@domain.com"
              required
            />
          </FormSection>

          <Button
            value={status.loading ? "Resetting password..." : "Reset Password"}
            style={{ width: "100%" }}
            onClick={handleSubmit}
            disabled={status.loading}
          />
        </div>
      </PageWrapper>
    </UnauthorisedPageSurface>
  );
};

export default ForgotPasswordPage;
